<script>
    import NormalPickerGroup from './NormalPickerGroup';
    import NormalMask from './NormalMask';
    import NormalInput from './NormalInput';
    // export component
    export default {
        name: 'normal-picker',
        props: {
            visible: {type: Boolean, default: false},
            withBody: {type: Boolean, default: true},
            border: {type: Boolean, default: true},
            placeholder: {type: String, default: ''},
            disabled: {type: Boolean, default: false},

            actions: {type: Array, default: () => []},
            groups: {type: Array, default: () => []},
            selected: {type: Array, default: () => []},

            leftBtn: {type: String, default: '取消'},
            rightBtn: {type: String, default: '确定'},
        },
        model: {
            prop: 'selected',
            event: 'change'
        },
        watch: {
            visible (nv) {
                this.show = nv;
            },
            actions (nv) {
                this.innerActions = nv;
            }
        },
        data () {
            return {
                show: this.visible,
                innerActions: this.actions.length > 0 ? this.actions : [
                    {
                        label: this.leftBtn,
                        onClick: e => {
                            this.handleClose(() => {
                                this.$emit('cancel', e);
                            });
                        }
                    },
                    {
                        label: this.rightBtn,
                        reflectDisabled: true,
                        onClick: () => this.handleChanges()
                    }
                ],
                closing: false,
                showText: '',
                hasDisabled: false
            };
        },
        methods: {
            handleChanges (cb) {
                this.handleClose(() => {
                    this.withBody && (this.showText = this.getShowText());
                    this.$emit('change', this.selected);
                    cb && cb();
                });
            },
            handleChange (item, i, groupIndex) {
                this.hasDisabled = i === -1 && !item;
                !this.hasDisabled && (this.selected[groupIndex] = i);
                this.$nextTick(() => {
                    this.$emit('groupChange', item, i, groupIndex, this.selected);
                });
            },
            handleClose (cb) {
                this.closing = true;
                this.$nextTick(() =>
                    setTimeout(() => {
                        this.handleVisible(false);
                        this.closing = false;
                        cb();
                    }, 200)
                );
            },
            renderActions () {
                let elActions = this.innerActions.map((action, i) => {
                    const {label, onClick, reflectDisabled} = action;
                    let cls = this.$util.classNames(
                        'normal-picker__action',
                        {
                            'normal-picker__action__disabled': reflectDisabled && this.hasDisabled,
                        }
                    );
                    return (
                        <a onClick={onClick.bind(this)} key={i}
                           class={cls}>
                            {' '}
                            {label}
                        </a>
                    );
                });
                return <div class="normal-picker__hd">{elActions}</div>;
            },
            renderGroups () {
                return this.groups.map((group, i) => {
                    return <NormalPickerGroup key={i} items={group}
                                              onChange={this.handleChange}
                                              groupIndex={i}
                                              defaultIndex={this.selected[i]}/>;
                });
            },
            handleVisible (visible = true) {
                if (this.disabled) return;
                this.show = visible;
            },
            getShowText () {
                return this.selected.map((v, idx) => {
                    return this.groups[idx][v].text;
                }).join(' · ');
            }
        },
        computed: {},
        components: {NormalMask, NormalPickerGroup, NormalInput},
        mounted () {
            this.showText = this.getShowText();
        },
        render () {
            const {disabled, show, border, placeholder, closing, showText, withBody} = this;
            const cls = this.$util.classNames(
                'normal-picker',
                {
                    'normal-animate-slide-up': show && !closing,
                    'normal-animate-slide-down': closing
                }
            );
            const maskCls = this.$util.classNames({
                'normal-animate-fade-in': show && !closing,
                'normal-animate-fade-out': closing
            });
            return (
                <div>
                    {withBody ? <normal-input nativeOnClick={this.handleVisible}
                                              disabled={disabled}
                                              readonly={true}
                                              border={border}
                                              value={showText}
                                              placeholder={placeholder}/> : false}
                    {show ? (
                        <div>
                            <normal-mask
                                class={maskCls}
                                nativeOnClick={e =>
                                    this.handleClose(() => {
                                        this.$emit('cancel', e);
                                    })
                                }
                            />
                            <div class={cls}>
                                {this.renderActions()}
                                <div class="normal-picker__bd">{this.renderGroups()}</div>
                            </div>
                        </div>
                    ) : false}
                </div>
            );
        }
    };


</script>


<style lang="less" scoped>
    @import "../../assets/less/widgets-var";


    /deep/ .normal-input {
        .px2rem(font-size, 32);
    }


</style>
